export default "__VITE_ASSET__BQGpFbbr__"